import {computed, inject, Injectable} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'


@Injectable({
  providedIn: 'root'
})
export class RoleHelper {

  private readonly config = inject(ConfigService)

  public isApprover = computed(() => {
    return this.config.roles().includes('profitCalcApprover')
  })

  public isAdmin = computed(() => {
    return this.config.roles().includes('profitCalcAdmin')
  })
}
